"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPoint = void 0;
const tslib_1 = require("tslib");
const HistoryStore_1 = require("../constructs/HistoryStore");
const enumerableDecorator_1 = require("../constructs/enumerableDecorator");
const GeoModelCommon_1 = require("./GeoModelCommon");
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * GeoPoint Point
 * For some reason it was thought a great idea not to name this class the same as the typeName (RE)
 */
const typeName = 'Point';
class GeoPoint extends GeoModelCommon_1.GeoModelCommon {
    constructor({ gatewayStatistics, ...ob }) {
        super({ ...ob, type: ob.type ?? typeName });
        this.gatewayStatistics = {};
        this.type = typeName;
        if (gatewayStatistics) {
            Object.entries(gatewayStatistics).forEach(([k, stats]) => {
                const historyStore = new HistoryStore_1.HistoryStore(stats);
                historyStore.setAutoTrim(true);
                historyStore.setMaxLength(10);
                this.gatewayStatistics[k] = historyStore;
            });
        }
        this.dsk = ob.id;
        debug && console.log('GeoPoint from Location, Model Common', this);
    }
    get position() {
        return this.location;
    }
    set position(position) {
        this.location = position;
    }
    updateGatewayStatistics({ gatewaySk, gatewayData }) {
        if (!this.gatewayStatistics[gatewaySk]) {
            this.gatewayStatistics[gatewaySk] = new HistoryStore_1.HistoryStore();
        }
        const { timestamp, ...data } = gatewayData;
        const stateSnapshot = {
            timestamp: timestamp ?? Date.now(),
            state: {},
        };
        const { rssi, snr } = gatewayData;
        stateSnapshot.state = Object.fromEntries(Object.entries({ rssi, snr }).filter(([k, v]) => typeof v === 'number'));
        this.gatewayStatistics[gatewaySk].push(stateSnapshot);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.GeoPoint = GeoPoint;
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], GeoPoint.prototype, "updateGatewayStatistics", null);
